export default "__VITE_ASSET__BEzFhcY___"